var map = {
	"./CoS-disabled.svg": "4877",
	"./analytics-disabled.svg": "bece",
	"./bag-disabled.svg": "76ee",
	"./brp-disabled.svg": "2846",
	"./calendar-disabled.svg": "764b",
	"./checks-disabled.svg": "13c7",
	"./cup-disabled.svg": "2f7b",
	"./document-disabled.svg": "996c",
	"./document-verified-disabled.svg": "50a3",
	"./edit-disabled.svg": "e834",
	"./entrance-disabled.svg": "86e6",
	"./glasses-disabled.svg": "eb4b",
	"./heart-disabled.svg": "219d",
	"./help-circle-disabled.svg": "edb9",
	"./inbox-disabled.svg": "a581",
	"./library-disabled.svg": "7ab2",
	"./like-disabled.svg": "cc36",
	"./medal-disabled.svg": "c895",
	"./megafon-disabled.svg": "4aa8",
	"./person-disabled.svg": "9e8c",
	"./pie-chart-disabled.svg": "b96a",
	"./plane-disabled.svg": "8db2",
	"./presentation-disabled.svg": "8941",
	"./puzzle-disabled.svg": "33b2",
	"./repair-disabled.svg": "4a61",
	"./rocket-disabled.svg": "dfac",
	"./search-disabled.svg": "a424",
	"./settings-disabled.svg": "6e30",
	"./shield-disabled.svg": "c963",
	"./smile-disabled.svg": "cd64",
	"./sparkle-disabled.svg": "3dbd",
	"./sync-disabled.svg": "28ec",
	"./web-disabled.svg": "4f27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2427";